import { LoanType, ProductType } from '@qred/shared-enums';
import { z } from 'zod';

export const LoanTypeSchema = z
  .string()
  .toUpperCase()
  .pipe(z.nativeEnum(LoanType));

export const ProductTypeLowercaseSchema = z
  .string()
  .toUpperCase()
  .pipe(z.nativeEnum(ProductType))
  .transform((val) => val.toLowerCase() as Lowercase<`${ProductType}`>);

export type ProductTypeLowercase = z.infer<typeof ProductTypeLowercaseSchema>;
